// Store di Vue. Qui vengono inizializzati i Service, Keycloak(IDP), recuperate e
// centralizzate le informazioni relative al votante e all'evento elettorale.

import Vue from "vue";
import Vuex from "vuex";
import CeoCbbService from "../services/CeoCbbService";
import i18n from "../i18n";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ceoCbbService: null,
    retIdentification: null,
    electionEvent: null,
    identityConfirmed: false,
    electionMode: null,
    passKey: null,
    keycloakLanguage: null
  },
  getters: {
    getCeoCbbService: state => {
      //console.debug("[store:getCeoCbbService]", state.ceoCbbService);
      return state.ceoCbbService;
    },
    getretIdentification: state => {
      return state.retIdentification;
    },
    getElectionEvent: state => {
      return state.electionEvent;
    },
    getidentityConfirmed: state => {
      return state.identityConfirmed;
    },
    getElectionMode: state => {
      return state.electionMode;
    },
    getPassKey: state => {
      return state.passKey;
    },
    getKeycloakLanguage: state => {
      return state.keycloakLanguage;
    }
  },
  mutations: {
    ceoCbbServiceSetter(state, ma) {
      state.ceoCbbService = ma;
    },
    retIdentificationSetter(state, vi) {
      state.retIdentification = vi;
    },
    electionEventSetter(state, ee) {
      state.electionEvent = ee;
    },
    identityConfirmedSetter(state, e) {
      state.identityConfirmed = e;
    },
    electionModeSetter(state, e) {
      state.electionMode = e;
    },
    passKeySetter(state, e) {
      state.passKey = e;
    },
    keycloakLanguageSetter(state, e) {
      state.keycloakLanguage = e;
    }
  },
  actions: {
    init: async (context, keycloak) => {
      // console.log("[store:init] inizializion CeoCbbService");
      const service = new CeoCbbService(keycloak);
      context.commit("ceoCbbServiceSetter", service);
      context.commit("keycloakLanguageSetter", keycloak.tokenParsed.locale);

      //console.log("getting voter infomations");
      let retIdentification = await service.retIdentification();

      // console.log(retIdentification);

      if (retIdentification.error) {
        //console.error(retIdentification.error);
        alert(retIdentification.error);
        keycloak.logoutFn();
      } else {
        context.commit("retIdentificationSetter", retIdentification);
      }
    }
    // destroy:(context)=>{

    // }
  },
  modules: {}
});
